import { MAX_FILES_TO_UPLOAD } from '../+state/documents.constants'
import { CuratedFileList } from '../domain/curated-file-list.model'

export function filterByMaximumFilesLength(files: File[]): CuratedFileList {
  const allowedFiles = files.slice(0, MAX_FILES_TO_UPLOAD)
  const notAllowedFiles = files.slice(MAX_FILES_TO_UPLOAD)

  return {
    files: allowedFiles,
    errors: notAllowedFiles.map(file => ({
      filename: file.name,
      message: `${file.name} could not be added. You reached the limit of upload documents. Only ${MAX_FILES_TO_UPLOAD} documents could be added in a single process.`
    }))
  }
}
